<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title pull-left">DOCUMENT MAIL</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="row">

      <!-- Subject -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>{{ lang?.subject }}</label>
          <input type="text" class="form-control" formControlName="mail_subject">
          <span class="text-danger"
            *ngIf="(createForm.controls.mail_subject?.touched || createFormSubmitted) && createForm.controls.mail_subject?.errors?.required">
            This field is required.
          </span>
        </div>
      </div>

      <!-- Sender -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>{{ lang?.sender }}</label>
          <input type="text" class="form-control" formControlName="mail_sender" [value]="senderMail" readonly>
          <span class="text-danger"
            *ngIf="(createForm.controls.mail_sender?.touched || createFormSubmitted) && createForm.controls.mail_sender?.errors?.required">
            This field is required.
          </span>          
        </div>
      </div>      

      <!-- Send to -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>{{ lang?.send_to }}</label>
          <input type="text" class="form-control" formControlName="send_to" >
          <span class="text-danger"
            *ngIf="(createForm.controls.send_to?.touched || createFormSubmitted) && createForm.controls.send_to?.errors?.required">
            This field is required.
          </span>              
        </div>
      </div>            

      <!-- Add CC -->
      <div class="form-group col-sm-12">

        <div class="col-sm-12" formArrayName="cc">
          <label>Add CC</label>
          <div class="form-group row" *ngFor="let a of createForm.get('cc')?.controls; let i = index" [formGroupName]="i">
            <div class="col-sm-11">
              <input type="text" class="form-control" formControlName="email">
            </div>
            <div class="col-sm-1">
              <button class="btn btn-primary pull-right" type="button" (click)="removeEmail(i)"
                *ngIf=" i!=(createForm.get('cc').controls.length-1) ">
                <i class="fa fa-trash-o"></i>
              </button>
              <button class="btn btn-primary pull-right" type="button" (click)="addEmail()"
                *ngIf=" i==(createForm.get('cc').controls.length-1) ">
                <i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
      </div>      

      <!-- Message Start-->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>{{lang?.notes}}</label>
          <textarea class="form-control" formControlName="mail_notes"></textarea>
          <span class="text-danger"
            *ngIf="(createForm.controls.mail_notes?.touched || createFormSubmitted) && createForm.controls.mail_notes?.errors?.required">
            This field is required.
          </span>            
        </div>
      </div>

      <!-- Message Edit-->

      <!-- Employees  -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
        <label>{{ lang?.employees }}</label>
        <select class="form-control" formControlName="mail_employees" multiple>
          <option value="">{{ lang?.select }}</option>
          <option *ngFor="let data of employee" [ngValue]="data?.employee_name">{{data?.employee_name}}</option>
        </select>
        <span class="text-danger"
        *ngIf="(createForm.controls.mail_employees?.touched || createFormSubmitted) && createForm.controls.mail_employees?.errors?.required">
        This field is required.
      </span>  
      </div>
    </div>      

    </div>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-success">{{ lang?.save }}</button>
    <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">{{ lang?.close }}</button>
  </div>
</form>